var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticClass: "title" },
        [
          _c(
            "el-breadcrumb",
            [
              _c("el-breadcrumb-item", [_vm._v("业务管理")]),
              _c("el-breadcrumb-item", [_vm._v("工单管理")]),
              _c("el-breadcrumb-item", [_vm._v("Dcops工单")]),
              _c("el-breadcrumb-item", [_vm._v("服务器故障")])
            ],
            1
          )
        ],
        1
      ),
      _c("div", { staticClass: "title-en" }, [_vm._v("搜索条件")]),
      _c("el-card", { staticClass: "box-card" }, [
        _c(
          "div",
          { staticClass: "search-container" },
          [
            _c(
              "el-form",
              {
                staticClass: "search-form",
                attrs: {
                  inline: true,
                  model: _vm.searchForm,
                  "label-width": "100px"
                }
              },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "派单时间" } },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                type: "daterange",
                                "range-separator": "-",
                                "start-placeholder": "开始",
                                "end-placeholder": "结束",
                                "value-format": "yyyy-MM-dd"
                              },
                              on: { change: _vm.syncDispatchFromRange },
                              model: {
                                value: _vm.dispatchDateRange,
                                callback: function($$v) {
                                  _vm.dispatchDateRange = $$v
                                },
                                expression: "dispatchDateRange"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "结单时间" } },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                type: "daterange",
                                "range-separator": "-",
                                "start-placeholder": "开始",
                                "end-placeholder": "结束",
                                "value-format": "yyyy-MM-dd"
                              },
                              on: { change: _vm.syncCompletedFromRange },
                              model: {
                                value: _vm.completedDateRange,
                                callback: function($$v) {
                                  _vm.completedDateRange = $$v
                                },
                                expression: "completedDateRange"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "超时时间" } },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                type: "daterange",
                                "range-separator": "-",
                                "start-placeholder": "开始",
                                "end-placeholder": "结束",
                                "value-format": "yyyy-MM-dd"
                              },
                              on: { change: _vm.syncOlaFromRange },
                              model: {
                                value: _vm.olaDateRange,
                                callback: function($$v) {
                                  _vm.olaDateRange = $$v
                                },
                                expression: "olaDateRange"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { staticClass: "time-filter-hint", attrs: { span: 24 } },
                      [
                        _vm._v(
                          "\n            以上三段时间为「且」关系；可不填。超时时间对应字段 olaTime（SLA 应完成时刻）。\n          "
                        )
                      ]
                    )
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "工单号" } },
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: "如 20260309045043",
                                clearable: ""
                              },
                              model: {
                                value: _vm.searchForm.ticketId,
                                callback: function($$v) {
                                  _vm.$set(_vm.searchForm, "ticketId", $$v)
                                },
                                expression: "searchForm.ticketId"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "时效" } },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  placeholder: "按 SLA 与状态筛选",
                                  clearable: ""
                                },
                                model: {
                                  value: _vm.searchForm.rd_olaTime,
                                  callback: function($$v) {
                                    _vm.$set(_vm.searchForm, "rd_olaTime", $$v)
                                  },
                                  expression: "searchForm.rd_olaTime"
                                }
                              },
                              [
                                _c("el-option", {
                                  attrs: {
                                    label: "预超时(在途且距 SLA≤2h)",
                                    value: "1"
                                  }
                                }),
                                _c("el-option", {
                                  attrs: {
                                    label: "超时-在途(SLA 已过)",
                                    value: "2"
                                  }
                                }),
                                _c("el-option", {
                                  attrs: {
                                    label: "超时-已结单(结单晚于 SLA)",
                                    value: "3"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "是否超时" } },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: { placeholder: "全部", clearable: "" },
                                model: {
                                  value: _vm.searchForm.isTimeOut,
                                  callback: function($$v) {
                                    _vm.$set(_vm.searchForm, "isTimeOut", $$v)
                                  },
                                  expression: "searchForm.isTimeOut"
                                }
                              },
                              [
                                _c("el-option", {
                                  attrs: { label: "是", value: "是" }
                                }),
                                _c("el-option", {
                                  attrs: { label: "否", value: "否" }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "故障单号" } },
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: "实例 ID / 敜障单号",
                                clearable: ""
                              },
                              model: {
                                value: _vm.searchForm.instanceId,
                                callback: function($$v) {
                                  _vm.$set(_vm.searchForm, "instanceId", $$v)
                                },
                                expression: "searchForm.instanceId"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "区域-园区" } },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  placeholder: "请选择",
                                  clearable: "",
                                  filterable: ""
                                },
                                on: { focus: _vm.handleSelectFocus },
                                model: {
                                  value: _vm.searchForm.campusName,
                                  callback: function($$v) {
                                    _vm.$set(_vm.searchForm, "campusName", $$v)
                                  },
                                  expression: "searchForm.campusName"
                                }
                              },
                              _vm._l(_vm.campusOptions, function(item) {
                                return _c("el-option", {
                                  key: item,
                                  attrs: { label: item, value: item }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "状态" } },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: { placeholder: "请选择", clearable: "" },
                                model: {
                                  value: _vm.searchForm.state,
                                  callback: function($$v) {
                                    _vm.$set(_vm.searchForm, "state", $$v)
                                  },
                                  expression: "searchForm.state"
                                }
                              },
                              [
                                _c("el-option", {
                                  attrs: { label: "已结单", value: "已结单" }
                                }),
                                _c("el-option", {
                                  attrs: { label: "运行中", value: "运行中" }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c("el-col", { attrs: { span: 6 } }),
                    _c("el-col", { attrs: { span: 6 } })
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c("el-col", { attrs: { span: 24 } }, [
                      _c(
                        "div",
                        { staticClass: "search-button" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.handleSearch }
                            },
                            [_vm._v("点击查询")]
                          ),
                          _c("el-button", { on: { click: _vm.handleReset } }, [
                            _vm._v("重置")
                          ]),
                          _c(
                            "el-button",
                            { on: { click: _vm.debouncedExport } },
                            [_vm._v(_vm._s(_vm.exportButtonText))]
                          )
                        ],
                        1
                      )
                    ])
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("div", { staticClass: "title-en" }, [_vm._v("服务器故障列表")]),
      _c("el-card", { staticClass: "box-card" }, [
        _c(
          "div",
          { staticClass: "table-container" },
          [
            _c(
              "div",
              { staticClass: "button-container" },
              [
                _c(
                  "el-button",
                  {
                    attrs: {
                      type: "success",
                      plain: "",
                      loading: _vm.syncLoading,
                      disabled: _vm.syncLoading
                    },
                    on: { click: _vm.openFaultUpdateMonthDialog }
                  },
                  [_vm._v("更新服务器列表")]
                ),
                _c("el-button", { on: { click: _vm.openColumnsDialog } }, [
                  _vm._v("表头设置")
                ])
              ],
              1
            ),
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading"
                  }
                ],
                ref: "table",
                attrs: { data: _vm.showData, border: "", stripe: "" },
                on: { "selection-change": _vm.handleSelectionChange }
              },
              [
                _c("el-table-column", {
                  attrs: { type: "selection", width: "55", align: "center" }
                }),
                _vm._l(_vm.visibleColumns, function(column, index) {
                  return _c("el-table-column", {
                    key: index,
                    attrs: {
                      prop: column.prop,
                      label: column.label,
                      width: column.width,
                      align: column.align,
                      fixed: column.fixed,
                      "show-overflow-tooltip":
                        !column.thumbs && !!column.tooltip
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              column.prop === "ticketId"
                                ? [
                                    scope.row.ticketId
                                      ? _c("span", [
                                          _vm._v(_vm._s(scope.row.ticketId))
                                        ])
                                      : _c("span", [_vm._v("-")])
                                  ]
                                : column.prop === "status"
                                ? [
                                    scope.row.status
                                      ? _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              type: _vm.statusTagType(
                                                scope.row.status
                                              ),
                                              size: "small"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(scope.row.status) +
                                                "\n              "
                                            )
                                          ]
                                        )
                                      : _c("span", [_vm._v("-")])
                                  ]
                                : column.prop === "isTimeOut"
                                ? [
                                    scope.row.isTimeOut
                                      ? _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              type:
                                                scope.row.isTimeOut === "是"
                                                  ? "danger"
                                                  : "success",
                                              size: "small"
                                            }
                                          },
                                          [_vm._v(_vm._s(scope.row.isTimeOut))]
                                        )
                                      : _c("span", [_vm._v("-")])
                                  ]
                                : column.prop === "lifeCycle"
                                ? [
                                    _c("div", { staticClass: "life-cycle" }, [
                                      _c("div", { staticClass: "life-step" }, [
                                        _c("div", {
                                          staticClass: "life-dot",
                                          class: {
                                            on: !!scope.row.dispatchTime
                                          }
                                        }),
                                        _c(
                                          "div",
                                          { staticClass: "life-step-meta" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "life-step-title"
                                              },
                                              [_vm._v("派单")]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "life-step-time" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.formatLifeCycleTime(
                                                      scope.row.dispatchTime
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]),
                                      _c("div", {
                                        staticClass: "life-line",
                                        class: {
                                          on:
                                            !!scope.row.dispatchTime &&
                                            !!scope.row.arriveIdcTime
                                        }
                                      }),
                                      _c("div", { staticClass: "life-step" }, [
                                        _c("div", {
                                          staticClass: "life-dot",
                                          class: {
                                            on: !!scope.row.arriveIdcTime
                                          }
                                        }),
                                        _c(
                                          "div",
                                          { staticClass: "life-step-meta" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "life-step-title"
                                              },
                                              [_vm._v("到达机房")]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "life-step-time" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.formatLifeCycleTime(
                                                      scope.row.arriveIdcTime
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]),
                                      _c("div", {
                                        staticClass: "life-line",
                                        class: {
                                          on:
                                            !!scope.row.arriveIdcTime &&
                                            !!scope.row.startOperateTime
                                        }
                                      }),
                                      _c("div", { staticClass: "life-step" }, [
                                        _c("div", {
                                          staticClass: "life-dot",
                                          class: {
                                            on: !!scope.row.startOperateTime
                                          }
                                        }),
                                        _c(
                                          "div",
                                          { staticClass: "life-step-meta" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "life-step-title"
                                              },
                                              [_vm._v("开始操作")]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "life-step-time" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.formatLifeCycleTime(
                                                      scope.row.startOperateTime
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]),
                                      _c("div", {
                                        staticClass: "life-line",
                                        class: {
                                          on:
                                            !!scope.row.startOperateTime &&
                                            !!scope.row.endOperateTime
                                        }
                                      }),
                                      _c("div", { staticClass: "life-step" }, [
                                        _c("div", {
                                          staticClass: "life-dot",
                                          class: {
                                            on: !!scope.row.endOperateTime
                                          }
                                        }),
                                        _c(
                                          "div",
                                          { staticClass: "life-step-meta" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "life-step-title"
                                              },
                                              [_vm._v("结束操作")]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "life-step-time" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.formatLifeCycleTime(
                                                      scope.row.endOperateTime
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ])
                                    ])
                                  ]
                                : column.thumbs
                                ? [
                                    column.prop === "completedDesc" ||
                                    column.prop === "timeOutDesc"
                                      ? [
                                          _c(
                                            "div",
                                            { staticClass: "desc-cell" },
                                            [
                                              column.copyable &&
                                              _vm.descFullText(
                                                scope.row,
                                                column.prop
                                              ) !== "-"
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "desc-cell-toolbar"
                                                    },
                                                    [
                                                      _c("el-button", {
                                                        staticClass:
                                                          "desc-cell-copy-btn",
                                                        attrs: {
                                                          type: "text",
                                                          size: "mini",
                                                          title: "复制本格全文",
                                                          icon:
                                                            "el-icon-document-copy"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                            return _vm.copyCellByProp(
                                                              scope.row,
                                                              column.prop
                                                            )
                                                          }
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm.imageUrlsForThumbColumn(
                                                scope.row,
                                                column
                                              ).length
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "attach-thumb-wrap"
                                                    },
                                                    [
                                                      _vm._l(
                                                        _vm
                                                          .imageUrlsForThumbColumn(
                                                            scope.row,
                                                            column
                                                          )
                                                          .slice(0, 4),
                                                        function(u, idx) {
                                                          return _c(
                                                            "el-image",
                                                            {
                                                              key:
                                                                "img-" +
                                                                column.prop +
                                                                "-" +
                                                                idx,
                                                              staticClass:
                                                                "attach-thumb",
                                                              attrs: {
                                                                src: u,
                                                                "preview-src-list": _vm.imageUrlsForThumbColumn(
                                                                  scope.row,
                                                                  column
                                                                ),
                                                                fit: "cover"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "attach-thumb-error",
                                                                  attrs: {
                                                                    slot:
                                                                      "error"
                                                                  },
                                                                  slot: "error"
                                                                },
                                                                [
                                                                  _c("i", {
                                                                    staticClass:
                                                                      "el-icon-picture-outline"
                                                                  })
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                      _vm.imageUrlsForThumbColumn(
                                                        scope.row,
                                                        column
                                                      ).length > 4
                                                        ? _c(
                                                            "el-popover",
                                                            {
                                                              attrs: {
                                                                placement:
                                                                  "left",
                                                                width: "340",
                                                                trigger: "click"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "attach-popover-grid"
                                                                },
                                                                _vm._l(
                                                                  _vm
                                                                    .imageUrlsForThumbColumn(
                                                                      scope.row,
                                                                      column
                                                                    )
                                                                    .slice(4),
                                                                  function(
                                                                    u,
                                                                    idx
                                                                  ) {
                                                                    return _c(
                                                                      "el-image",
                                                                      {
                                                                        key:
                                                                          "pm-" +
                                                                          column.prop +
                                                                          "-" +
                                                                          idx,
                                                                        staticClass:
                                                                          "attach-thumb attach-thumb--sm",
                                                                        attrs: {
                                                                          src: u,
                                                                          "preview-src-list": _vm.imageUrlsForThumbColumn(
                                                                            scope.row,
                                                                            column
                                                                          ),
                                                                          fit:
                                                                            "cover"
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "attach-thumb-error",
                                                                            attrs: {
                                                                              slot:
                                                                                "error"
                                                                            },
                                                                            slot:
                                                                              "error"
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "i",
                                                                              {
                                                                                staticClass:
                                                                                  "el-icon-picture-outline"
                                                                              }
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    )
                                                                  }
                                                                ),
                                                                1
                                                              ),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "attach-more-ref",
                                                                  attrs: {
                                                                    slot:
                                                                      "reference"
                                                                  },
                                                                  slot:
                                                                    "reference"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                        +" +
                                                                      _vm._s(
                                                                        _vm.imageUrlsForThumbColumn(
                                                                          scope.row,
                                                                          column
                                                                        )
                                                                          .length -
                                                                          4
                                                                      ) +
                                                                      "\n                      "
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ],
                                                    2
                                                  )
                                                : _vm._e(),
                                              _c(
                                                "el-tooltip",
                                                {
                                                  attrs: {
                                                    effect: "dark",
                                                    placement: "top-start",
                                                    content: _vm.descFullText(
                                                      scope.row,
                                                      column.prop
                                                    )
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "desc-text"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            _vm.descShortText(
                                                              scope.row,
                                                              column.prop
                                                            )
                                                          ) +
                                                          "\n                    "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      : [
                                          !_vm.urlCountForThumbs(
                                            scope.row,
                                            column
                                          )
                                            ? _c(
                                                "div",
                                                { staticClass: "attach-empty" },
                                                [
                                                  column.thumbsFromHtml
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "thumb-text-fallback"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.textFallbackForThumbColumn(
                                                                scope.row,
                                                                column.prop
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    : _c("span", [_vm._v("-")])
                                                ]
                                              )
                                            : _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "attach-thumb-wrap"
                                                },
                                                [
                                                  _vm._l(
                                                    _vm
                                                      .urlsForThumbs(
                                                        scope.row,
                                                        column
                                                      )
                                                      .slice(0, 4),
                                                    function(u, idx) {
                                                      return [
                                                        _vm.isImageUrl(u)
                                                          ? _c(
                                                              "el-image",
                                                              {
                                                                key:
                                                                  "img-" +
                                                                  column.prop +
                                                                  "-" +
                                                                  idx,
                                                                staticClass:
                                                                  "attach-thumb",
                                                                attrs: {
                                                                  src: u,
                                                                  "preview-src-list": _vm.imageUrlsForThumbColumn(
                                                                    scope.row,
                                                                    column
                                                                  ),
                                                                  fit: "cover"
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "attach-thumb-error",
                                                                    attrs: {
                                                                      slot:
                                                                        "error"
                                                                    },
                                                                    slot:
                                                                      "error"
                                                                  },
                                                                  [
                                                                    _c("i", {
                                                                      staticClass:
                                                                        "el-icon-picture-outline"
                                                                    })
                                                                  ]
                                                                )
                                                              ]
                                                            )
                                                          : _c(
                                                              "a",
                                                              {
                                                                key:
                                                                  "file-" +
                                                                  column.prop +
                                                                  "-" +
                                                                  idx,
                                                                staticClass:
                                                                  "attach-file-chip",
                                                                attrs: {
                                                                  href: u,
                                                                  target:
                                                                    "_blank",
                                                                  rel:
                                                                    "noopener",
                                                                  title:
                                                                    "打开附件"
                                                                }
                                                              },
                                                              [
                                                                _c("i", {
                                                                  staticClass:
                                                                    "el-icon-document"
                                                                })
                                                              ]
                                                            )
                                                      ]
                                                    }
                                                  ),
                                                  _vm.urlsForThumbs(
                                                    scope.row,
                                                    column
                                                  ).length > 4
                                                    ? _c(
                                                        "el-popover",
                                                        {
                                                          attrs: {
                                                            placement: "left",
                                                            width: "340",
                                                            trigger: "click"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "attach-popover-grid"
                                                            },
                                                            [
                                                              _vm._l(
                                                                _vm
                                                                  .urlsForThumbs(
                                                                    scope.row,
                                                                    column
                                                                  )
                                                                  .slice(4),
                                                                function(
                                                                  u,
                                                                  idx
                                                                ) {
                                                                  return [
                                                                    _vm.isImageUrl(
                                                                      u
                                                                    )
                                                                      ? _c(
                                                                          "el-image",
                                                                          {
                                                                            key:
                                                                              "pm-" +
                                                                              column.prop +
                                                                              "-" +
                                                                              idx,
                                                                            staticClass:
                                                                              "attach-thumb attach-thumb--sm",
                                                                            attrs: {
                                                                              src: u,
                                                                              "preview-src-list": _vm.imageUrlsForThumbColumn(
                                                                                scope.row,
                                                                                column
                                                                              ),
                                                                              fit:
                                                                                "cover"
                                                                            }
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "attach-thumb-error",
                                                                                attrs: {
                                                                                  slot:
                                                                                    "error"
                                                                                },
                                                                                slot:
                                                                                  "error"
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "i",
                                                                                  {
                                                                                    staticClass:
                                                                                      "el-icon-picture-outline"
                                                                                  }
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _c(
                                                                          "a",
                                                                          {
                                                                            key:
                                                                              "pf-" +
                                                                              column.prop +
                                                                              "-" +
                                                                              idx,
                                                                            staticClass:
                                                                              "attach-file-chip attach-file-chip--sm",
                                                                            attrs: {
                                                                              href: u,
                                                                              target:
                                                                                "_blank",
                                                                              rel:
                                                                                "noopener",
                                                                              title:
                                                                                "打开附件"
                                                                            }
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "i",
                                                                              {
                                                                                staticClass:
                                                                                  "el-icon-document"
                                                                              }
                                                                            )
                                                                          ]
                                                                        )
                                                                  ]
                                                                }
                                                              )
                                                            ],
                                                            2
                                                          ),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "attach-more-ref",
                                                              attrs: {
                                                                slot:
                                                                  "reference"
                                                              },
                                                              slot: "reference"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                      +" +
                                                                  _vm._s(
                                                                    _vm.urlsForThumbs(
                                                                      scope.row,
                                                                      column
                                                                    ).length - 4
                                                                  ) +
                                                                  "\n                    "
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ],
                                                2
                                              )
                                        ]
                                  ]
                                : column.prop === "faultDesc"
                                ? [
                                    _c(
                                      "div",
                                      { staticClass: "fault-desc-with-copy" },
                                      [
                                        _c(
                                          "el-tooltip",
                                          {
                                            attrs: {
                                              effect: "dark",
                                              placement: "top-start",
                                              content: _vm.formatCell(
                                                scope.row,
                                                column.prop
                                              )
                                            }
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "fault-desc-text"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.formatCell(
                                                      scope.row,
                                                      column.prop
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm.hasCopyableFaultDesc(scope.row)
                                          ? _c("el-button", {
                                              staticClass:
                                                "fault-desc-copy-btn",
                                              attrs: {
                                                type: "text",
                                                size: "mini",
                                                title: "复制本格内容",
                                                icon: "el-icon-document-copy"
                                              },
                                              on: {
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                  return _vm.copyCellByProp(
                                                    scope.row,
                                                    "faultDesc"
                                                  )
                                                }
                                              }
                                            })
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  ]
                                : _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatCell(scope.row, column.prop)
                                      )
                                    )
                                  ])
                            ]
                          }
                        }
                      ],
                      null,
                      true
                    )
                  })
                })
              ],
              2
            ),
            _c(
              "el-dialog",
              {
                attrs: {
                  title: "选择月份范围",
                  visible: _vm.monthSelectDialogVisible,
                  "append-to-body": true,
                  width: "700px",
                  "close-on-click-modal": false,
                  "custom-class": "month-select-dialog",
                  "modal-append-to-body": false,
                  "destroy-on-close": true
                },
                on: {
                  "update:visible": function($event) {
                    _vm.monthSelectDialogVisible = $event
                  }
                }
              },
              [
                _c(
                  "el-form",
                  {
                    attrs: {
                      model: _vm.monthSelectForm,
                      "label-width": "100px"
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "开始月份" } },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            type: "month",
                            placeholder: "选择开始月份",
                            format: "yyyy-MM",
                            "value-format": "yyyy-MM"
                          },
                          model: {
                            value: _vm.monthSelectForm.startMonth,
                            callback: function($$v) {
                              _vm.$set(_vm.monthSelectForm, "startMonth", $$v)
                            },
                            expression: "monthSelectForm.startMonth"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "结束月份" } },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            type: "month",
                            placeholder: "选择结束月份",
                            format: "yyyy-MM",
                            "value-format": "yyyy-MM"
                          },
                          model: {
                            value: _vm.monthSelectForm.endMonth,
                            callback: function($$v) {
                              _vm.$set(_vm.monthSelectForm, "endMonth", $$v)
                            },
                            expression: "monthSelectForm.endMonth"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "dialog-footer",
                    attrs: { slot: "footer" },
                    slot: "footer"
                  },
                  [
                    _c(
                      "el-button",
                      {
                        on: {
                          click: function($event) {
                            _vm.monthSelectDialogVisible = false
                          }
                        }
                      },
                      [_vm._v("取消")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.confirmFaultMonthSelect }
                      },
                      [_vm._v("确定")]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "el-dialog",
              {
                attrs: {
                  title: "设置显示项",
                  visible: _vm.showColumnsDialog,
                  "append-to-body": true,
                  width: "400px",
                  "close-on-click-modal": false,
                  "custom-class": "columns-dialog",
                  "modal-append-to-body": false,
                  "destroy-on-close": true
                },
                on: {
                  "update:visible": function($event) {
                    _vm.showColumnsDialog = $event
                  }
                }
              },
              [
                _c(
                  "el-checkbox-group",
                  {
                    staticClass: "checkbox-group",
                    model: {
                      value: _vm.selectedColumns,
                      callback: function($$v) {
                        _vm.selectedColumns = $$v
                      },
                      expression: "selectedColumns"
                    }
                  },
                  _vm._l(_vm.columns, function(column) {
                    return _c(
                      "el-checkbox",
                      {
                        key: column.prop,
                        staticClass: "checkbox-item",
                        attrs: { label: column.prop }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(column.label) +
                            "\n          "
                        )
                      ]
                    )
                  }),
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "dialog-footer",
                    attrs: { slot: "footer" },
                    slot: "footer"
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small" },
                        on: { click: _vm.selectAllColumns }
                      },
                      [_vm._v("全选")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small" },
                        on: { click: _vm.restoreDefaultColumns }
                      },
                      [_vm._v("恢复默认")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small", type: "primary" },
                        on: { click: _vm.saveColumnsDialog }
                      },
                      [_vm._v("保存")]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "pagination-container" },
              [
                _c("el-pagination", {
                  attrs: {
                    "current-page": _vm.currentPage,
                    "page-sizes": [10, 20, 30, 50],
                    "page-size": _vm.pageSize,
                    layout: "total, sizes, prev, pager, next, jumper",
                    total: _vm.total
                  },
                  on: {
                    "size-change": _vm.handleSizeChange,
                    "current-change": _vm.handleCurrentChange
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }